module.exports = __webpack_public_path__ + "static/media/text.6b77dac0.svg";